enum RedirectionErrorTypeEnum {
  CustomerCancelled = 'customer_cancelled',
  ProviderTemporarilyUnavailable = 'provider_temporarily_unavailable',
  ProviderPermanentlyUnavailable = 'provider_permanently_unavailable',
  UnexpectedError = 'unexpected_error'
}

export default RedirectionErrorTypeEnum;